import {chkObject, objectToArrayClean} from "./components/utils/Utils";
import {proxy} from "valtio";

export const state = proxy({
  
  appTitle: '',
  modelFileFormat: '',
  modelsFolderLocation:'',
  // set this - in "app-data.json"
  // modelsFolderLocation: 'https://development.modeconfigurator.com/products/SVIL/models/',
  materialsLocation: '',
  
  appReady: false,
  userDevice: '',
  featureOpenStatus: false,
  
  get fileFormat() {
    return this.modelFileFormat;
  },
  
  get folderLocation() {
    return this.modelsFolderLocation;
  },
  
  get gltfModelLocation() {
    return this.mainModelLocation
  },
  
  //  state of app
  get currUserDevice() {
    return this.userDevice;
  },
  
  get isLoaded() {
    return this.appReady;
  },
  
  get openStatus() {
    return this.featureOpenStatus;
  },
/*
   main control object
   Material.003 === MFC
   Material.007 === Handle
*/
modelsInAction: {
  //static:null,
  //frame: null,
  //tray1: null,
  static:{'121/static': {"materialOverride": "","scaleOverride": [1,1,1]}},
  frame: {'121/frame': {"materialOverride": "Silver Metal","scaleOverride": [1,1,1]}},
  tray1: {'121/tray1': {"materialOverride": "Tropical Orange Plastic","scaleOverride": [1,1,1]}},
  tray2: {'121/tray2': {"materialOverride": "Tropical Orange Plastic","scaleOverride": [1,1,1]}},
  tray3: {'121/tray3': {"materialOverride": "Tropical Orange Plastic","scaleOverride": [1,1,1]}},
},
  
  // get main object - format to array - remove any which are not in use
  get getCurrModels() {
    return objectToArrayClean(this.modelsInAction).filter(function (data) {
      return data != null;
    });
  },
  
});

// set model / texture from api
export const setModel = (payload) => {
  Object.keys(payload).forEach((prop) => {
    let payloadPropValue = Object.values(payload[prop]);
    let errorValue;
    let materialCheck = Object.values(payloadPropValue).filter(material=>
      {
        material = material.materialOverride;
        let returnValue = material === '';
        if(!returnValue)
        {
          if(typeof(material === 'string'))
          {
            returnValue = materialState.mainMaterialSets.materials.some(mainMaterial=>
              {
                return mainMaterial.title === material;
              });
          }
          else
          {
            returnValue = Object.values(material).some(matName=>{
              return materialState.mainMaterialSets.materials.find(mainMaterial=>
                {
                  return mainMaterial.title === matName
                });
            });
          }
        }
        if(!returnValue) errorValue = material;
        return returnValue;
      });
    if(materialCheck.length > 0) state.modelsInAction[prop] = payload[prop];
    else console.error(`The value provided is not valid for ${prop}`, errorValue);
  });
}

// sets state for feature - open / close
export const setFeatureChange = (status) => {
  state.featureOpenStatus = status;
}

/*
   ------------------------------------------------------------
   ------------------------------------------------------------
   material sets
*/
export const materialState = proxy({
  
  mainMaterialSets:{},

  doubleSided: true,
  
  get selectedMaterialGroup() {
    return Object.keys(this.mainMaterialSets)[0];
  },
  
  get materialSets() {
    return this.mainMaterialSets;
  },
  
});

export const toggleDoubleSided = () =>
{
  materialState.doubleSided = !materialState.doubleSided;
  console.log(materialState.doubleSided);
}

/*
   ------------------------------------------------------------
   ------------------------------------------------------------
   AR section
*/
export const arState = proxy({
  
  arGroupVis: true,
  
  get getGroupVis() {
    return this.arGroupVis;
  }
  
});

export const setGroupVis = (val) => {
  arState.arGroupVis = val;
}

/*
   ------------------------------------------------------------
   ------------------------------------------------------------
   camera section
*/
export const cameraState = proxy({
  
  currCamPosition: 0,
  camPositions: {},
  developerControls: false,
  
  get developerControlsStatus() {
    return this.developerControls;
  },
  
  get camaraPositions() {
    return chkObject(this.camPositions) ? this.camPositions : false;
  },
  
  get currentCamPos() {
    return this.currCamPosition;
  },
  
  get camPositionsTotal() {
    return Object.keys(this.camPositions).length;
  }
  
});

export const setCameraPos = (status) => {
  
  if (status === 'index_forward') {
    cameraState.currCamPosition += 1;
    if (cameraState.currCamPosition >= cameraState.camPositionsTotal) {
      cameraState.currCamPosition = 0;
    }
  } else {
    cameraState.currCamPosition -= 1;
    if (cameraState.currCamPosition < 0) {
      cameraState.currCamPosition = cameraState.camPositionsTotal - 1;
    }
  }
}
/*
   ------------------------------------------------------------
*/
